export default "__VITE_ASSET__BY$OPv3G__"